import { GHG_REPORT_COVER_PDF_CSS } from "./ghgReportCoverPdfCss.generated";

const GHG_REPORT_PDF_PAGE_BREAKS = `
  @page {
    size: A4 portrait;
  }

  body > div {
    padding: 0 !important;
    margin: 0 !important;
  }

  [class*="cover_page"],
  [class*="toc_page"],
  [class*="exec_page"],
  [class*="general_page"],
  [class*="report_page"] {
    min-height: auto !important;
    margin-bottom: 0 !important;
    page-break-after: auto !important;
    break-after: auto !important;
    page-break-inside: auto !important;
    break-inside: auto !important;
    page-break-before: auto !important;
    break-before: auto !important;
  }

  [data-ghg-report-edit-ui] {
    display: none !important;
  }

  /* Cover page — full-bleed rules live in getGhgReportFirstPagePdfCss() (appended last). */

  [class*="cover_body"] {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }

  /* Force new page only for intro sections — NOT every report_page block */
  [class*="toc_page"],
  [class*="exec_page"],
  [class*="general_page"] {
    page-break-before: always !important;
    break-before: page !important;
    margin-top: 1px !important;
  }

  [class*="cover_title"] {
    text-decoration: none !important;
    text-shadow: none !important;
  }

  [class*="cover_info_label"] {
    display: block !important;
    letter-spacing: 0.04em !important;
    word-spacing: normal !important;
  }

  [class*="cover_info_value"] {
    display: block !important;
    text-shadow: none !important;
  }

  [class*="cover_info_grid"] {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
  }

  [class*="cover_info_item"] {
    display: flex !important;
    flex-direction: column !important;
  }

  /* Executive Summary intro page — match Figma typography in PDF */
  [class*="exec_page"] {
    font-family: "Inter", Arial, sans-serif !important;
  }

  [class*="exec_main_title"] {
    font-family: "Inter", Arial, sans-serif !important;
    font-size: 2rem !important;
    font-weight: 700 !important;
    color: #000000 !important;
    line-height: 1.25 !important;
    text-decoration: none !important;
    text-align: left !important;
    margin: 0 0 1.75rem !important;
  }

  [class*="exec_info_box"] {
    font-family: "Inter", Arial, sans-serif !important;
    background-color: #498151 !important;
  }

  [class*="exec_info_label"],
  [class*="exec_info_value"] {
    font-family: "Inter", Arial, sans-serif !important;
    font-size: 1rem !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
    color: #ffffff !important;
  }

  div[class*="page_break"],
  div[class*="pageBreak"],
  div[class*="page-break"] {
    display: none !important;
    height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }
`;

const GHG_REPORT_LEGACY_PDF_CSS = `

        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        
        * {
          box-sizing: border-box;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
        
        body {
          font-family: Inter, Arial, sans-serif;
          margin: 0;
          padding: 0;
          color: #000;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        .table {
          width: 60%;
          margin-top: 1rem;
        }

        .logo {
          width: auto;
          height: 80px;
          margin-bottom: 1rem;
        }

        .page_break {
          display: block;
          height: 0;
          page-break-before: always !important;
          break-before: page !important;
          margin: 0;
          padding: 0;
        }

        .pageBreak {
          display: block;
          height: 0;
          page-break-before: always !important;
          break-before: page !important;
          margin: 0;
          padding: 0;
        }

        /* Support for CSS module hashed class names - page breaks */
        div[class*="page_break"],
        div[class*="pageBreak"],
        div[class*="page-break"] {
          display: block !important;
          height: 0 !important;
          page-break-before: always !important;
          break-before: page !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        /* Also support inline style page breaks */
        [style*="page-break-before: always"],
        [style*="pageBreakBefore: always"],
        [style*="break-before: page"],
        [style*="breakBefore: page"] {
          page-break-before: always !important;
          break-before: page !important;
        }

        .table_heading {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          letter-spacing: 0.5px;
        }

        .table_value {
          font-family: Inter;
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 0.5px;
        }

        .heading {
          font-family: Inter;
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
          letter-spacing: 0.5px;
        }

        .heading_bold {
          font-weight: 700 !important;
        }

        /* Support for CSS module hashed class names - heading_bold */
        [class*="heading_bold"] {
          font-weight: 700 !important;
        }

        .sub_heading {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          letter-spacing: 0.5px;
          margin-left: 1rem;
        }

        .sub_heading_graph {
          font-family: Inter;
          font-size: 16px;
          font-weight: 600;
          line-height: 25.6px;
          color: rgba(102, 102, 102, 0.8);
        }

        .direct_emission_div {
          background-color: #fcfcfc;
          padding: 1rem;
          border-radius: 12px;
          margin-top: 1rem;
        }

        .scope_emission_div {
          margin-top: 2rem;
        }

        .vehicle_div {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .sub_sub_heading {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          letter-spacing: 0.5px;
          color: rgba(0, 0, 0, 1);
          margin-top: 2rem;
        }

        .sub_sub_heading.heading_bold,
        [class*="sub_sub_heading"][class*="heading_bold"] {
          font-weight: 700 !important;
        }

        .sub_main_heading {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          line-height: 22px;
          letter-spacing: 0.5px;
          font-style: italic;
        }

        .company_footer {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 0.5rem;
          flex-direction: column;
          margin-top: 2rem;
        }

        .summary_heading {
          font-family: Inter;
          font-weight: 600;
          opacity: 90%;
        }

        .summary_heading.heading_bold,
        [class*="summary_heading"][class*="heading_bold"] {
          font-weight: 700 !important;
        }

        .summary_subheading {
          font-family: Inter;
          font-size: 14px;
          opacity: 70%;
          margin-top: -0.5rem;
        }

        .summary_text {
          font-family: Inter;
          font-size: 12px;
          opacity: 70%;
          line-height: 1.25rem;
          padding: 0 1rem;
          margin-bottom: 1rem;
        }

        .report_metadata_table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 1rem;
        }

        .report_metadata_table tr {
          border-bottom: none;
        }

        .report_metadata_table td {
          padding: 0.25rem 0;
          text-align: left;
        }

        .summary_chart_container {
          display: flex !important;
          flex-direction: row !important;
          gap: 2rem;
          margin-top: 1.5rem;
          align-items: flex-start;
          width: 100%;
          justify-content: flex-start;
        }

        .summary_table_wrapper {
          width: 35%;
          max-width: 400px;
          min-width: 300px;
          flex-shrink: 0;
        }

        .summary_table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          background-color: #ffffff;
          table-layout: auto;
        }

        .summary_table thead {
          background-color: #1C486B;
        }

        .summary_table_header {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          padding: 0.5rem;
          border: 1px solid #ddd;
          background-color: #1C486B;
          color: #ffffff;
          text-align: left;
        }

        .summary_table_header:last-child {
          text-align: right;
        }

        .summary_table_cell {
          font-family: Inter;
          font-size: 14px;
          padding: 0.5rem;
          border: 1px solid #ddd;
          text-align: left;
          background-color: #ffffff;
        }

        .summary_table_cell[style*="text-align: right"] {
          text-align: right;
        }

        .summary_table tbody tr {
          background-color: #ffffff;
        }

        /* Support for CSS module hashed class names using attribute selectors */
        table[class*="summary_table"] {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          background-color: #ffffff;
          table-layout: auto;
        }

        table[class*="summary_table"] thead {
          background-color: #1C486B;
        }

        table[class*="summary_table"] th[class*="summary_table_header"] {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          padding: 0.5rem;
          border: 1px solid #ddd;
          background-color: #1C486B;
          color: #ffffff;
          text-align: left;
        }

        table[class*="summary_table"] th[class*="summary_table_header"]:last-child {
          text-align: right;
        }

        table[class*="summary_table"] td[class*="summary_table_cell"] {
          font-family: Inter;
          font-size: 14px;
          padding: 0.5rem;
          border: 1px solid #ddd;
          text-align: left;
          background-color: #ffffff;
        }

        table[class*="summary_table"] td[class*="summary_table_cell"][style*="text-align: right"] {
          text-align: right;
        }

        table[class*="summary_table"] tbody tr {
          background-color: #ffffff;
        }

        .pie_chart_wrapper {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          min-width: 300px;
        }

        .emission_breakdown_table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 1rem;
          background-color: #ffffff;
          border: 1px solid #ddd;
          table-layout: auto;
        }

        .emission_breakdown_table th:first-child,
        .emission_breakdown_table td:first-child {
          width: 15%;
        }

        .emission_breakdown_table th:nth-child(2),
        .emission_breakdown_table td:nth-child(2) {
          width: 60%;
        }

        .emission_breakdown_table th:nth-child(3),
        .emission_breakdown_table td:nth-child(3) {
          width: 25%;
          text-align: right;
        }

        .emission_breakdown_table thead {
          background-color: #1C486B;
        }

        .emission_table_header {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          padding: 0.75rem;
          border: 1px solid #ddd;
          background-color: #1C486B;
          color: #ffffff;
          text-align: left;
        }

        .emission_table_header:last-child {
          text-align: right;
        }

        .emission_breakdown_table tbody {
          background-color: #ffffff;
        }

        .emission_table_cell {
          font-family: Inter;
          font-size: 14px;
          padding: 0.75rem;
          border: 1px solid #ddd;
          text-align: left;
          vertical-align: middle;
          background-color: #ffffff;
        }

        .emission_breakdown_table tbody tr {
          background-color: #ffffff;
        }

        /* Additional styles for emission breakdown table using summary_table class */
        /* These styles ensure the table at line 1188 renders correctly in PDF */
        table.summary_table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          background-color: #ffffff;
          table-layout: auto;
          margin-top: 1.5rem;
        }

        table.summary_table thead {
          background-color: #1C486B;
        }

        table.summary_table th.emission_table_header {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          padding: 0.75rem;
          border: 1px solid #ddd;
          background-color: #1C486B;
          color: #ffffff;
          text-align: left;
        }

        table.summary_table th.emission_table_header:last-child {
          text-align: right;
        }

        table.summary_table td.emission_table_cell {
          font-family: Inter;
          font-size: 14px;
          padding: 0.75rem;
          border: 1px solid #ddd;
          text-align: left;
          vertical-align: middle;
          background-color: #ffffff;
        }

        table.summary_table td.emission_table_cell[style*="text-align: right"] {
          text-align: right;
        }

        table.summary_table tbody tr {
          background-color: #ffffff;
        }

        /* Support for CSS module hashed class names using attribute selectors */
        table[class*="summary_table"] {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          background-color: #ffffff;
          table-layout: auto;
          margin-top: 1.5rem;
        }

        table[class*="summary_table"] thead {
          background-color: #1C486B;
        }

        table[class*="summary_table"] th[class*="emission_table_header"] {
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          padding: 0.75rem;
          border: 1px solid #ddd;
          background-color: #1C486B;
          color: #ffffff;
          text-align: left;
        }

        table[class*="summary_table"] th[class*="emission_table_header"]:last-child {
          text-align: right;
        }

        table[class*="summary_table"] td[class*="emission_table_cell"] {
          font-family: Inter;
          font-size: 14px;
          padding: 0.75rem;
          border: 1px solid #ddd;
          text-align: left;
          vertical-align: middle;
          background-color: #ffffff;
        }

        table[class*="summary_table"] tbody tr {
          background-color: #ffffff;
        }

        /* Additional styles for proper rendering */
        table {
          border-collapse: collapse;
          width: 100%;
        }

        ul {
          margin-left: 1.5rem;
          padding: 0;
        }

        li {
          margin-bottom: 0.5rem;
        }

        h1:not([class*="cover_title"]):not([class*="exec_main_title"]) {
          font-family: "Inter", Arial, sans-serif;
          font-size: 24px;
          font-weight: 700;
          text-decoration: underline;
          margin-bottom: 1rem;
          margin-top: 0;
          text-align: left;
        }

        img {
          max-width: 100%;
          height: auto;
        }

        /* Material-UI Table overrides for PDF */
        .MuiTableContainer-root {
          margin-top: 1rem;
          background-color: #ffffff;
        }

        .MuiTable-root {
          width: 100%;
          border-collapse: collapse;
        }

        .MuiTableHead-root {
          background-color: #1C486B;
        }

        .MuiTableCell-head {
          background-color: #1C486B !important;
          color: #ffffff !important;
          font-family: Inter;
          font-size: 14px;
          font-weight: 600;
          padding: 8px;
          border: 1px solid #ddd;
        }

        .MuiTableCell-body {
          background-color: #ffffff;
          font-family: Inter;
          font-size: 14px;
          padding: 8px;
          border: 1px solid #ddd;
        }

        .MuiTableRow-root {
          background-color: #ffffff;
        }

        /* Additional page break support - ensure they work in PDF */
        div.page-break,
        div[class*="page-break"] {
          display: block !important;
          height: 0 !important;
          width: 100% !important;
          page-break-before: always !important;
          break-before: page !important;
          margin: 0 !important;
          padding: 0 !important;
          border: none !important;
        }
`;

/** Must match backend puppeteer page.pdf margins in /generate-pdf */
// Must equal the margins the backend's /generate-pdf prints with when the
// report header is on (showReportHeader: true): top 30mm, bottom
// PDF_FOOTER_BOTTOM_MARGIN (10mm). The cover wrapper is 297mm tall and pulled
// out with negative margins of exactly these values; if they're off, the
// wrapper no longer fits the page's content box and Chrome splits it —
// pushing the cover's company name / period / date onto page 2.
export const GHG_PDF_BACKEND_MARGINS = {
  top: "30mm",
  right: "10mm",
  bottom: "10mm",
  left: "10mm",
};

/**
 * First-page-only PDF CSS — bleeds cover into backend margins (frontend-only fix).
 * Uses negative margin only (no top/left position) + object-fit/background cover.
 */
export function getGhgReportFirstPagePdfCss() {
  const { top, right, bottom, left } = GHG_PDF_BACKEND_MARGINS;

  return `
  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  [data-ghg-pdf-cover-wrapper="true"] {
    display: block !important;
    box-sizing: border-box !important;
    position: relative !important;
    width: 210mm !important;
    height: 297mm !important;
    min-width: 210mm !important;
    min-height: 297mm !important;
    margin: -${top} -${right} -${bottom} -${left} !important;
    padding: 0 !important;
    overflow: hidden !important;
    border-radius: 0 !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    page-break-after: always !important;
    break-after: page !important;
  }

  [data-ghg-pdf-cover-wrapper="true"] [data-ghg-pdf-cover-page="true"],
  [data-ghg-pdf-cover-wrapper="true"] [class*="cover_page"] {
    display: block !important;
    box-sizing: border-box !important;
    width: 100% !important;
    height: 100% !important;
    min-height: 297mm !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 !important;
    overflow: hidden !important;
    position: relative !important;
    background-size: cover !important;
    background-position: center center !important;
    background-repeat: no-repeat !important;
  }

  [data-ghg-pdf-cover-wrapper="true"] [class*="cover_bg"] {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    min-width: 100% !important;
    min-height: 100% !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
    object-fit: cover !important;
    object-position: center center !important;
    z-index: 0 !important;
    display: block !important;
  }

  [data-ghg-pdf-cover-wrapper="true"] [class*="cover_overlay"] {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    z-index: 1 !important;
    pointer-events: none !important;
  }

  [data-ghg-pdf-cover-wrapper="true"] [class*="cover_content"] {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    z-index: 2 !important;
    box-sizing: border-box !important;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: calc(${top} + 48px) calc(${left} + 56px) calc(${bottom} + 48px) calc(${left} + 56px) !important;
    display: flex !important;
    flex-direction: column !important;
    border-radius: 0 !important;
  }

  [data-ghg-pdf-cover-wrapper="true"] [class*="cover_body"] {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }

  [data-ghg-pdf-cover-wrapper="true"] [class*="cover_title"] {
    text-decoration: none !important;
    text-shadow: none !important;
  }
`;
}

export function getGhgReportPdfStyles() {
  return `
    ${GHG_REPORT_LEGACY_PDF_CSS}
    ${GHG_REPORT_COVER_PDF_CSS}
    ${GHG_REPORT_PDF_PAGE_BREAKS}
  `;
}
